var ns;
(function () {
  var SessionController = function ($scope, $location, $http, $window, $routeParams, $controller, SessionsService, ModalFactory, UnitsService, IfApisService, FileIOService, MAX_RESULT_ERROR, $q, $filter, $interval, ApiExportStatusMsgFactory) {
    $controller('BaseController', {$scope: $scope});

    $scope.executeType = null;
    var executeTypes = {"0":{"type":"export","title":"データをAPI出力します"},"1":{"type":"import","title":"データをAPI取込します"}};
    var primaryKey = "units_id";
    var checkedUnits = [];

    document.getElementById('unittop').style.display="none";
    $scope.registClicked = false;
    $scope.entry = function () {
      $scope.registClicked = true;
      var checkedAttrs = [];
      for(var i = 0; i<$scope.kg.dataSource.data().length; i++){
        var item = $scope.kg.dataSource.at(i);
        if(item.checked){
          checkedAttrs.push(item.id);
        }
      }
      if(checkedAttrs.length == 0){
        ModalFactory.createIModal("E001");
        $scope.registClicked = false;
        return;
      }
      $scope.postEntry(checkedAttrs);
    };
    $scope.onUnitClick = function(dataItem){
      $scope.postEntry([dataItem.id]);
    };
    $scope.checkAllSelected = function () {
      var allChecked = true;
      for(var i = 0; i<$scope.kg.dataSource.data().length; i++){
        var item = $scope.kg.dataSource.at(i);
        if(!item.checked){
          allChecked = false;
          break;
        }
      }
      $scope._checkAll = allChecked;
      $('#checkAll').prop("checked", allChecked);
    };
    $scope.postEntry = function(checkedAttrs){
      SessionsService.postSessions(checkedAttrs)
      .success(function () {
        location.href = 'unittop';
      });
      $scope.registClicked = false;
    };
    $scope.SelectAll = function(ev) {
      var items = $scope.kg.dataSource.data();
      $scope._checkAll = ev.target.checked;
      items.forEach(function (item) {
        item.checked = ev.target.checked;
      });
    };

    $scope.gridOptions = {
      dataSource: {
        serverPaging: false,
        serverSorting: false,
        pageSize: 100,
        transport: {
          read: {
            url: 'api/v2/units/available',
            dataType: "json"
          }
        },

        schema: {
          model: {
            fields: {
              nm: {type: "string"},
              end_dttm: {type: "code"},
              dsc: {type: "string"},
              owners_nm: {type: "string"},
              warehouses_nm: {type: "string"},
              stt_dttm: {type: "date"},
              material_qty: {type: "number"},
              sh_qty: {type: "number"},
              ar_qty: {type: "number"},
              last_got_at: {type: "date"}
            }
          },
          parse: function(response) {
            var dataLen = response.length;
            for (var cnt=0; cnt < dataLen; cnt++) {
              if (!response[cnt].end_dttm) {
                response[cnt].end_dttm = "稼働中";
              } else {
                response[cnt].end_dttm = "停止中";
              }
            }
            return response;
          }
        }
      },
        ignoreCase: false,
        filter: "gte",
        resizable: true,
        columnMenu: true,
        reorderable: true,
        scrollable: {
          virtual: true
        },
        height: $(document).height() - 230,
        sortable: {
          mode: "multiple",
          allowUnsort: true
        },
        pageable: true,
        filterable: {
          mode: "row",
          extra: true,
          operators: {
            string: {
              contains: "含む",
              doesnotcontain: "含まない",
              startswith: "始まる",
              endswith: "終わる",
              eq: "等しい",
              neq: "等しくない",
            },
            number: {
              eq: "等しい",
              neq: "等しくない",
              gte: "以上",
              lte: "以下",
              gt: "より大きい",
              lt: "より小さい",
            },
            date: {
              gte: "以降",
              lte: "以前",
              lt: "より前",
              gt: "より後",
              eq: "等しい",
              neq: "等しくない",
            },
            code: {
              eq: "等しい",
              neq: "等しくない",
            }
          }
        },
        schema: {
          model: {
            fields: {
              nm: {type: "string"},
              end_dttm: {type: "code"},
              dsc: {type: "string"},
              owners_nm: {type: "string"},
              warehouses_nm: {type: "string"},
              stt_dttm: {type: "date"},
              material_qty: {type: "number"},
              sh_qty: {type: "number"},
              ar_qty: {type: "number"},
              last_got_at: {type: "date"}
            }
          }
        },
        columns: [
          {field: "check_row", title: "<input id='checkAll' ng-model='_checkAll' type='checkbox' title='Select all' ng-click='SelectAll($event)'/>",
            width: 50, sortable: false, filterable: false, locked: true, lockable: false, template: '<input ng-model = "dataItem.checked" type="checkbox" ng-change="checkAllSelected()" />' },
          {field: "nm", title: "ユニット", width: "200px",
            template: function (dataItem) {
              return "<div ng-click='onUnitClick(dataItem)'><a href='#'>" + dataItem.nm + "</a></div>";
            }
          },
          {field: "dsc", title: "ユニット説明", width: "200px"},
          {field: "end_dttm", title: "ステータス", width: "200px",
            template: function (dataItem) {
              if(dataItem.end_dttm == "稼働中"){
                color = "rgb(161, 234, 119)";
                fontcolor = "black";
              }
              else{
                color = "gray";
                fontcolor = "white";
              }
              return "<div style='background-color:" + color + ";color:" + fontcolor + ";text-align:center;'>" + dataItem.end_dttm + "</div>";
            },
            filterable: {
              cell: {
                template: function (args) {
                  args.element.kendoDropDownList({
                    dataSource: [
                      {text:'', value:null},
                      {text:'稼働中', value:'稼働中'},
                      {text:'停止中', value:'停止中'}
                    ],
                    dataTextField: "text",
                    dataValueField: "value",
                    valuePrimitive: true
                  });
                }
              }
            }
          },
          {field: "owners_nm", title: "オーナー", width: "200px"},
          {field: "warehouses_nm", title: "システム倉庫", width: "200px"},
          {field: "stt_dttm", title: "利用開始日", width: "200px", template: "#= kendo.toString(kendo.parseDate(stt_dttm, 'yyyy-MM-dd'), 'yyyy/MM/dd') #"},
          {field: "material_qty", title: "商品マスタ残件数", width: "152px",
            template: function(dataItem) {
              if (dataItem.status == null) {
                value = "未取得";
              } else if(dataItem.status == "00") {
                value = dataItem.material_qty;
              } else if(dataItem.status == "01") {
                value = "取得中";
              } else {
                value = "取得失敗";
              }
              return value;
            }
          },
          {field: "sh_qty", title: "出荷指示残件数", width: "152px",
            template: function(dataItem) {
              if (dataItem.status == null) {
                value = "未取得";
              } else if(dataItem.status == "00") {
                value = dataItem.sh_qty;
              } else if(dataItem.status == "01") {
                value = "取得中";
              } else {
                value = "取得失敗";
              }
              return value;
            }
          },
          {field: "ar_qty", title: "入荷予定残件数", width: "152px",
            template: function(dataItem) {
              if (dataItem.status == null) {
                value = "未取得";
              } else if(dataItem.status == "00") {
                value = dataItem.ar_qty;
              } else if(dataItem.status == "01") {
                value = "取得中";
              } else {
                value = "取得失敗";
              }
              return value;
            }
          },
          {field: "last_got_at", title: "最終取得日時", width: "170px",
            template: "#= (last_got_at == null) ? ' ' : kendo.toString(kendo.parseDate(last_got_at, 'yyyy-MM-dd HH:mm:ss'), 'yyyy/MM/dd HH:mm:ss') #"
          },
        ]
      };
    $scope.registOwner = function(isSysMgr){
      $scope.registClicked = true;
      if (isSysMgr) {
        location.href = '/owner';
      } else {
        ModalFactory.createIModal("E017");
        $scope.registClicked = false;
      }
    };
    $scope.registWarehouse = function(isSysMgr){
      $scope.registClicked = true;
      if (isSysMgr) {
        location.href = '/warehouse';
      } else {
        ModalFactory.createIModal("E017");
        $scope.registClicked = false;
      }
    };
    $scope.createUnit = function(isSysMgr){
      $scope.registClicked = true;
      if (isSysMgr) {
        location.href = '/unit';
      } else {
        ModalFactory.createIModal("E017");
        $scope.registClicked = false;
      }
    };
    $scope.userList = function(isSysMgr){
      $scope.registClicked = true;
      if (isSysMgr) {
        location.href = '/user';
      } else {
        ModalFactory.createIModal("E017");
        $scope.registClicked = false;
      }
    };
    $scope.contract = function(isSysMgr){
      $scope.registClicked = true;
      if (isSysMgr) {
        location.href = '/company';
      } else {
        ModalFactory.createIModal("E017");
        $scope.registClicked = false;
      }
    };
    $scope.getHttpIfApiGetCountBtnCaption = function() {
      IfApisService.getHttpIfApiGetCountBtnCaption().success(function (data) {
        $scope.repossessionMessage = data.data.text;
      }).error(function (data) {
        $scope.repossessionMessage = "";
      })
    };
    $scope.getHttpIfApiGetCounts = function () {
      if ($('#btn-repossession').hasClass('btn-disabled')) {
        return false;
      }

      $('#btn-repossession').addClass('btn-disabled');
      $scope.repossessionMessage = "件数取得中";

      var errorCnt = 0;
      var grid = $('#grid').data('kendoGrid').dataSource.data();
      var queStack = [];

      for (var i = 0, gridLength = grid.length; i < gridLength; i++) {
        var item = grid.at(i);

        if(item.end_dttm == '稼働中'){
          if (errorCnt == MAX_RESULT_ERROR) {
            item.set('status', '99');
          } else {
            queStack.push(IfApisService.getHttpIfApiGetCounts({unit_id:item.id, index:i}).success(function(data){
              var tmpGrid = $('#grid').data('kendoGrid').dataSource.data();
              var tmpItem = tmpGrid.at(data.data.index);

              if (data.data[0].status_cd == '00') {
                errorCnt = 0;
                var results = data.data[0].record;
                tmpItem.status = '00';
                tmpItem.material_qty = results.material_qty;
                tmpItem.sh_qty = results.sh_qty;
                tmpItem.ar_qty = results.ar_qty;
                tmpItem.last_got_at = results.last_got_at;
              } else {
                errorCnt++;
                tmpItem.status = data.data[0].status_cd;
                tmpItem.last_got_at = data.data[0].record.last_got_at;
              }
              $('#grid').data('kendoGrid').refresh();
            }).error(function() {
              $scope.repossessionMessage = "致命的なエラーが発生しました。";
            }));
          }
        }
      }
      var promise = $q.all(queStack);
      promise.then(
        function() {
          $('#grid').data('kendoGrid').dataSource.read();
          $scope.repossessionMessage = "再取得が完了しました。10分後に再取得可能になります。";
        }
      );
    };

    $scope.showModalSystemLinks = function(isSysMgr) {
      if (isSysMgr) {
        checkedUnits = [];
        for(var i = 0; i<$scope.kg.dataSource.data().length; i++){
          var item = $scope.kg.dataSource.at(i);
          if(item.checked){
            checkedUnits.push(item.id);
          }
        }
        if (checkedUnits.length == 0) {
          ModalFactory.createIModal("E001");
          return;
        }

        $scope.checkTopUnits = checkedUnits;

        IfApisService.getUnitIfApiAllData({unit_ids:checkedUnits})
          .success(function (results) {
            $scope.apiList = results.data;
            if (results.data.length > 0) {
              $scope._modalSystemLinksShow = true;
              $scope.disableApiLinkButton = false;
            } else {
              ModalFactory.createIModal("E017");
            }
          })
          .error(function () {
            ModalFactory.createIModal("E999");
          })
      } else {
        ModalFactory.createIModal("E017");
        return;
      }
    }

    $scope.hideModalSystemLinks = function() {
      $scope._modalSystemLinksShow = false;
    }

    $scope.linkHttpIfApi = function () {
      var selectedApi = $filter('filter')($scope.apiList, function (value) {
        return value.isCheck != false;
      });
      if (selectedApi.length > 0) {
        var inputApi = $filter('filter')($scope.apiList, function (value) {
          if (value.isCheck == true && value.is_input == '1') {
            return true;
          }
          return false;
        });
        var outputApi = $filter('filter')($scope.apiList, function (value) {
          if (value.isCheck == true && value.is_input == '0') {
            return true;
          }
          return false;
        });
        if (inputApi.length > 0 && outputApi.length > 0) {
          ModalFactory.createIModalByStr("取込と出力は同時に行えません。");
          return;
        } else if(inputApi.length > 0) {
          $scope.executeType = executeTypes[1]["type"];
          $scope.modalIfApisActionTitle = executeTypes[1]["title"];
        } else {
          $scope.executeType = executeTypes[0]["type"];
          $scope.modalIfApisActionTitle = executeTypes[0]["title"];
        }
        //モーダルを表示
        $scope._modalIfApisActionShow = true;

      } else {
        ModalFactory.createIModal("E031");
        return;
      }
    }

    $scope.execute = function() {
      if (!$scope.executeType) {
        ModalFactory.createIModalByStr("取込か出力を選択して下さい。")
          .then(function(){
          });
        return;
      }
      var selectedApi = $filter('filter')($scope.apiList, function (value) {
        return value.isCheck != false;
      });

      var selectedUnits = $scope.checkTopUnits;

      if ($scope.executeType == "import") {
        $scope.startLoading();
        IfApisService.pullImportDataForTop({
          "ids[]": selectedApi,
          "unit_ids[]": selectedUnits
        }).success(function (data) {
          var resultIds = [];
          var msg = "";
          var nextf = 0;
          var noticeMsg = "";
          for (var i=0,len = data.data.length; i < len; i++) {
            if ((data.data[i].status_cd != "00")&&(data.data[i].status_cd != "91")) {
              if (data.data[i].status_cd == "9999") {
                noticeMsg += data.data[i].unit_name + " " + data.data[i].process_name + "：" + data.data[i].if_result.msg + "<br>";
              } else {
                msg += data.data[i].unit_name + " " + data.data[i].process_name + "：(" + data.data[i].status_cd + ")" + data.data[i].if_result.msg + "<br>";
              }
            } else {
              if (data.data[i].status_cd != "00") {
                nextf++;
              }
              resultIds.push(data.data[i].if_result.id);
            }
          }
          if(msg){
            $scope.stopLoading();
            ModalFactory.createIModalByStrWithTag("IF連携が失敗しました。<br>" + msg)
              .then(function(){
              });
            if (resultIds.length === 0) {
              return;
            } else {
              $scope.startLoading();
            }
          }
          if (nextf > 0) {
            noticeMsg += "取込データに続きがあります<br>";
          }

          if (resultIds.length === 0) {
            $scope.stopLoading();
            ModalFactory.createIModalByStrWithTag("選択されたシステム連携は利用不可に設定されています。")
              .then(function(){
              });
            return;
          }

          IfApisService.executeImportActionForTop({
            "result_ids[]" : resultIds
          }).success(function (res) {
            $scope.asyncBatchIfImport(res.data.result, noticeMsg, selectedUnits);
          })
        }).error(function (data)
        {
          $scope.stopLoading();
        });
      } else if($scope.executeType == "export") {
        $scope.startLoading();
        $fromDate = $scope.toLocaleString($scope.from_date);
        $toDate = $scope.toLocaleString($scope.to_date);
        IfApisService.executeExportActionForTop({"ids[]": selectedApi, "from_date": $fromDate, "to_date": $toDate, "unit_ids[]": selectedUnits})
          .success(function (res)
          {
            if (res.data.error) {
              $scope.stopLoading();
              ModalFactory.createEModalByServerData(res);
            }
            else {
              if (res.data.result.ids.length === 0) {
                $scope.stopLoading();
                ModalFactory.createIModalByStrWithTag("選択されたシステム連携は利用不可に設定されています。")
                  .then(function(){
                  });
                return;
              }
              $scope.asyncBatchIfExport(res.data.result, res.data.msg, selectedUnits);
            }
          }).error(function (res)
        {
          $scope.stopLoading();
          ModalFactory.createEModalByServerData(res);
        });
      } else {
        $scope.stopLoading();
        ModalFactory.createIModalByStr("不正な値が入力されました")
          .then(function(){
          });
      }
    }

    // IFの出力状況を定期で確認する。
    $scope.asyncBatchIfExport = function (params, noticeMsg, selectedUnits)
    {
      var getPromise = function (params)
      {
        var deferred = $q.defer();

        var promise = $interval(function ()
          {
            deferred.notify();
            var ids = [];
            var length = params.ids.length;
            for (var i = 0; i < length; i++) {
              ids.push(params.ids[i]);
            }
            FileIOService.getBatchIfStatusForTop({"ids[]":ids, "unit_ids[]":selectedUnits})
              .success(function (data)
              {
                if (params.ids.length == data.length) {
                  var is_error = false;
                  var is_not_finish = true;
                  var count = 0;
                  for (var i = 0; i < data.length; i++) {
                    // エラーがあれば終了。
                    if (data[i].is_finished == 1) {
                      // エラーがあれば終了。
                      if (data[i].err_cnt > 0) {
                        is_error = true;
                        break;
                      }
                      count++;
                    }
                  }
                  if(count ==  data.length){
                    is_not_finish = false;
                    $interval.cancel(promise);
                  }
                  if (!is_error) {
                    if(is_not_finish == false) {
                      IfApisService.pushExecutedExportDataForTop(data)
                        .success(function (data)
                        {
                          var successMsg = "";
                          var errorMsg = "";
                          for (var i = 0; i < data.data.length; i++) {
                            if (data.data[i].err_cnt > 0) {
                              //エラーがあれば終了
                              deferred.resolve(data.data[i].pth);
                              return;
                            }
                            else {
                              var statusCd = data.data[i].status_cd.split("\r\n");
                              if (statusCd[0] == '00') {
                                successMsg += data.data[i].unit_name + " " + data.data[i].process_name + "<br>";
                              } else {
                                errorMsg += data.data[i].unit_name + " " + data.data[i].process_name + " : ";
                                errorMsg += statusCd[0] + " ";
                                errorMsg += ApiExportStatusMsgFactory.createMsg(statusCd[0]) + "<br>";
                              }
                            }
                          }
                          if (successMsg !== "") {
                            successMsg = "API連携が完了しました。<br>" + successMsg;
                            if (noticeMsg !== "") {
                              successMsg = successMsg + "<br>" + noticeMsg;
                            }
                          }
                          if (errorMsg !== "") {
                            errorMsg = "API連携が失敗しました。<br>" + errorMsg;
                          }
                          var msg = successMsg + errorMsg;
                          $scope.stopLoading();
                          ModalFactory.createIModalByStrWithTag(msg)
                            .then(function(){
                              deferred.resolve(data.pth);
                            });
                        })
                        .error(function ()
                        {
                          $scope.stopLoading();
                          ModalFactory.createIModalByStr("API連携途中でエラーが発生しました。")
                            .then(function(){
                              deferred.reject(data.pth);
                            });
                        });
                    }
                  }
                  else {
                    //IF連携失敗
                    $scope.stopLoading();
                    ModalFactory.createIModalByStr("API連携途中でエラーが発生しました。")
                      .then(function(){
                        deferred.reject(data.pth);
                      });
                  }
                }
                else{
                  for (var i = 0; i < data.length; i++) {
                    // エラーがあれば終了。
                    if (data[i]['msg']) {
                      $scope.stopLoading();
                      deferred.reject(data[i]['pth']);
                      $interval.cancel(promise);
                    }
                  }
                }
              })
              .error(function ()
              {
                deferred.reject();
                $interval.cancel(promise);
                $scope.stopLoading();
                ModalFactory.createIModalByStr('サーバーとの通信に失敗しました')
                  .then(function(){
                    $scope.disableExportButton = false;
                  });
              });
          }
          , 1000);

        return deferred.promise;
      };

      var promise = getPromise(params);

      promise.then(
        function (path)
        {

        },
        function (msg)
        {

        },
        function ()
        {
        }
      )
    };

    // IFの出力状況を定期で確認する。
    $scope.asyncBatchIfImport = function (params, noticeMsg, selectedUnits)
    {
      var getPromise = function (params)
      {
        var deferred = $q.defer();
        var promise = $interval(function ()
          {
            deferred.notify();
            var ids = [];
            var length = params.ids.length;
            for (var i = 0; i < length; i++) {
              ids.push(params.ids[i]);
            }
            FileIOService.getBatchIfStatusForTop({"ids[]":ids, "unit_ids[]":selectedUnits})
              .success(function (data)
              {
                var is_error = false;
                var is_not_finish = true;
                var count = 0;
                for (var i = 0; i < data.length; i++) {
                  // エラーがあれば終了。
                  if (data[i].is_finished == 1) {
                    // エラーがあれば終了。
                    if (data[i].err_cnt > 0) {
                      is_error = true;
                      break;
                    }
                    count++;
                  }
                }
                if(count ==  data.length){
                  is_not_finish = false;
                  $interval.cancel(promise);
                }

                if (noticeMsg != "") {
                  noticeMsg = "<br>" + noticeMsg;
                }

                if (!is_error) {
                  if (!is_not_finish) {
                    $scope.stopLoading();
                    ModalFactory.createIModalByStrWithTag("ファイル取込みが完了しました。\r\n取込結果は取込履歴画面を参照してください。" + noticeMsg)
                      .then(function(){
                        deferred.resolve(data.pth);
                      });
                  }
                }
                else {
                  //IF連携失敗
                  $interval.cancel(promise);
                  $scope.stopLoading();
                  ModalFactory.createIModalByStrWithTag("ファイル取込み途中でエラーが発生しました。" + noticeMsg)
                    .then(function(){
                      deferred.resolve(data.pth);
                    });
                }
              })
              .error(function ()
              {
                deferred.reject();
                $interval.cancel(promise);
                $scope.stopLoading();
                ModalFactory.createIModalByStr('サーバーとの通信に失敗しました')
                  .then(function(){
                    $scope.disableExportButton = false;
                  });
              });
          }
          , 1000);

        return deferred.promise;
      };

      var promise = getPromise(params);

      promise.then(
        function (path)
        {

        },
        function (msg)
        {

        },
        function ()
        {
        }
      )
    };

    $scope.hideModalIfApisAction = function () {
      $scope._modalIfApisActionShow = false;
    }
    $scope.toLocaleString = function ( date )
    {
      return [
        date.getFullYear(),
        date.getMonth() + 1,
        date.getDate()
      ].join( '/' );
    }
    $scope.initDate = function() {
      var today = new Date();
      $scope.from_date = today;
      $scope.to_date = today;
    }
  };
  //add dependency
  SessionController.$inject = [
    '$scope', '$location', '$http', '$window', '$routeParams', '$controller', 'SessionsService', 'ModalFactory', 'UnitsService', 'IfApisService', 'FileIOService', 'MAX_RESULT_ERROR', '$q', '$filter', '$interval', 'ApiExportStatusMsgFactory'
  ];
  ns.App.controller('SessionController', SessionController);

}());
